import Vue from 'vue'
import Affix from 'vue-affix'
Vue.use(Affix)

import VScrollLock from 'v-scroll-lock' 
Vue.use(VScrollLock)
